module.exports = __webpack_public_path__ + "static/DashboardVid-ca4eaa6d5c79c028382cbd733c6cd9a3.mp4";